import { IonContent } from '@ionic/react';
import styled from 'styled-components';

export const IonContentLogin = styled(IonContent)`
  --background: radial-gradient(circle at 9.44% -7.92%, #dd88ff 0, #9970ff 25%, #4e55fd 50%, #003bc7 75%, #002496 100%);
`;
